import styled from '@emotion/styled'
import { ButtonBase } from '@mui/material'
import { size } from '@styles/theme'
import { PiXBold } from 'react-icons/pi'

const PreviewContainer = styled.div`
  position: relative;
  flex-shrink: 0;
  
  max-width: width;
  overflow: hidden;
  aspect: 1;
  border-radius: 15px;
  
  transform: scale(0);
  opacity: 0;
`

const RemoveButton = styled(ButtonBase)`
  position: absolute;
  top: ${size(1)};
  right: ${size(1)};
  
  padding: ${size(0.75)};
  border: 0.5px solid rgba(165,165,165, 0.75);
  border-radius: 100px;
  
  background-color: rgba(150,150,150, 0.75);
  z-index: 1;
`

const ImageView = styled.img`
  height: 100%;
  border-radius: 4px;
  object-fit: cover;
  cursor: zoom-in;
  opacity: 0;
  transform: scale(0);
`

const PreviewImage = ({ file, fileUrl, resetFileState, height=30, width='100%' }) => {
  return (
    <PreviewContainer
      style={{ width, maxHeight: size(height), border: file ? '0.5px solid rgba(150,150,150, 0.25)' : 'none' }}
      className='animation__scaleload'>
      <RemoveButton
        alt='Remove Uploaded Media'
        onClick={() => resetFileState()}>
        <PiXBold size={size(2)} />
      </RemoveButton>
      <ImageView
        style={{ width, maxHeight: size(height) }}
        className='animation__scaleload'
        alt="Image Uploaded"
        src={fileUrl}
      />
    </PreviewContainer>
  )
}

export { PreviewImage }
